define('BannerMessageView',[
    'backbone',
    'jquery',
    'router',
    'MessageView',
    'template!blocks/messages/banner',
    'app',
    'InternalLinkView',
    'LocalStorage',
    'UI',
], function (Backbone, $, router, MessageView, BannerTemplate,
             app,
             InternalLinkView,
             LocalStorage,
             UI
    ) {
    var TRANSITION_DURATION = 500;
    var bannerAnimationRafId;
    //var view;
    var shouldDisplayShowMoreButton = true;
    return MessageView.extend({
        render: function () {
            var view = this;
            view.$el.html(BannerTemplate(view));
            view.show();
        },
        className:'notifications__wrapper',
        show: function () {
            var view = this, bannerEl = view.$el;
            $('#banners-top').append(bannerEl);
            view.listenTo(app,'updateDocumentDimensions scroll', view.onScrollAndResize);
            view.listenTo(Backbone.history,'route', view.onScrollAndResize);
            view.$('.notifications.banner').toggleClass('show-more',view.isMessageOverflowing());
            view.onScrollAndResize();
            if(view.page === 'listing'){
                app.trigger('toggleTopBanner',true);
            }
            view.$('.icon-cross').on('click', function () {
                view.dismiss();
                return false;
            });

            view.$('.banner__show-more').on('click', function () {
                view.showMore();
                return false;
            })

            view.$el.on('click',function(e){
                var link;
                if(!!(link = view.$('a').get(0))){
                    if(e.target !== link){
                        view.$('a').click();
                    }
                    view.dismiss();
                }
                return false;
            });
            InternalLinkView.initializeLinksOfView(view);
        },
        isMessageOverflowing: function () {
            return this.$('.notifications.banner__content').isOverflowing();
        },
        showMore: function () {
            var view = this;
            view.$('.notifications.banner')
                .addClass('unwrapped')
                .removeClass('show-more');
            view.$('.notifications.banner__show-more').remove();
            shouldDisplayShowMoreButton = false;
            bannerAnimationRafId = requestAnimationFrame($.proxy(view.animateMessageHeight,view));
        },
        animateMessageHeight: function () {
            var view = this;
            if (view.isMessageOverflowing()) {
                var contentBanner = view.$('.notifications.banner__content'),
                    contentRealHeight;
                contentRealHeight = contentBanner.height() + 6;
                contentBanner.css('height', contentRealHeight);
                bannerAnimationRafId = requestAnimationFrame($.proxy(view.animateMessageHeight,view));
            } else {
                cancelAnimationFrame(bannerAnimationRafId);
            }
        },
        hide:function(){
          this.remove();
        },
        remove:function(){
            var view = this;
            view.$('.notifications').slideUp(TRANSITION_DURATION,function(){
                MessageView.prototype.remove.apply(view);
            });
            app.trigger('toggleTopBanner',false);
        },
        onScrollAndResize: function () {
            var view = this;
            //
            if (shouldDisplayShowMoreButton) {
                view.$('.notifications.banner').toggleClass('show-more',view.isMessageOverflowing());
            }else{
                var bannerContents = view.$('.notifications.banner__content').contents(),
                    textNode = bannerContents
                    [bannerContents.length - 1];
                var range = document.createRange();
                range.selectNodeContents(textNode);
                var textNodeHeight = range.getBoundingClientRect().height;
                bannerContents.not('.banner__icon').css('height', textNodeHeight + 6);
            }

            if(view.page === 'home' && $('.home').length){
                var scrollTop = app.get('scrollTop');
                app.trigger('toggleTopBanner',scrollTop===0);
            }

        },
    });
});
